import { render, staticRenderFns } from "./FormOrderFormButtons.vue?vue&type=template&id=51b58d5d&scoped=true&"
import script from "./FormOrderFormButtons.vue?vue&type=script&lang=js&"
export * from "./FormOrderFormButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b58d5d",
  null
  
)

export default component.exports